import { render, staticRenderFns } from "./avatarsList.vue?vue&type=template&id=2c20618b&scoped=true&"
import script from "./avatarsList.vue?vue&type=script&lang=js&"
export * from "./avatarsList.vue?vue&type=script&lang=js&"
import style0 from "./avatarsList.vue?vue&type=style&index=0&id=2c20618b&lang=scss&scoped=true&"
import style1 from "./avatarsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20618b",
  null
  
)

export default component.exports